import { useState } from 'react';

const useOriginHost = () => {
  const [hasOriginHost, setHasOriginHost] = useState(false);

  function defineOriginHost(event) {
      window.originHost = event.origin;
      setHasOriginHost(true);
  }

  function loadOriginHost() {
    if (!hasOriginHost) {
      const onMessageReceived = event => defineOriginHost(event);
      if (window.addEventListener) {
        window.addEventListener('message', onMessageReceived.bind(this), false);
      } else {
        window.attachEvent('onmessage', onMessageReceived.bind(this));
      }
    }
  }

  return {
    hasOriginHost,
    loadOriginHost
  };
};

export default useOriginHost;
